<div id="content" [ngClass]="{ banner: !isMobile, banner_mobile: isMobile }">
	<div [ngClass]="{ 'content-text': !isMobile, 'content-text_mobile': isMobile }">
		<span slot="header" class="header_mobile">{{ 'title-banner' | translate }}</span>
		<span slot="body" class="body_mobile">{{ 'desc-banner' | translate }}</span>
		<div slot="footer" class="footer_mobile">
			<imv-ui-button eid="init-banner-button" [disabled]="disableInitButton" theme="primary" fullWidth="true" (click)="navigateQuestionnaire()">
				<span slot="text">{{ 'button-banner' | translate }}</span>
			</imv-ui-button>
		</div>
	</div>
</div>
<div class="imv-wrapper">
	<div class="imv-wrapper__easy-read">
		<div class="imv-wrapper__easy-read__button__container">
			<p class="imv-wrapper__easy-read__text">
				{{ 'easy-read.easy-read-btn-content' | translate }}
			</p>
			<div class="imv-wrapper__easy-read__button">
				<div class="imv-wrapper__easy-read__button__image" [ngClass]="{ 'imv-wrapper__easy-read__button__image--no-easy-read': easyRead }"></div>
				<button class="imv-wrapper__easy-read__button__link" eid="init-easy-read" (click)="toggleEasyRead()">
					@if (!easyRead) {
						<span [innerHTML]="'easy-read.easy-read-view-content' | translate"></span>
					} @else {
						<span>{{ 'easy-read.no-easy-read-btn-content' | translate }}</span>
					}
				</button>
			</div>
		</div>
	</div>
	<p [ngClass]="{ 'imv-wrapper__text--easy-read': easyRead }">{{ 'portal-info' | translate }}</p>
	<div [ngClass]="easyRead ? 'imv-wrapper__box-link imv-wrapper__box-link--easy-read' : 'imv-wrapper__box-link'">
		<imv-ui-box-link
			eid="recover-draft-link"
			[ariaRoleDescription]="'link'"
			[ariaLabel]="'accede al borrador'"
			[extraIcon]="'imagen borrador'"
			class="imv-wrapper__box-link--left"
			draft="true"
			(keyup.enter)="navigateRequest()"
			(keyup.space)="navigateRequest()"
			(click)="navigateRequest()"
		>
			<span slot="text">{{ 'draft-boxlink' | translate }}</span>
		</imv-ui-box-link>
		<imv-ui-box-link
			eid="recover-expedient-link"
			class="imv-wrapper__box-link--right"
			draft="false"
			[ariaRoleDescription]="'link'"
			[ariaLabel]="'gestiona solicitud presentada'"
			(keyup.enter)="navigateConsult()"
			(keyup.space)="navigateConsult()"
			(click)="navigateConsult()"
		>
			<span slot="text">{{ 'status-boxlink' | translate }}</span>
		</imv-ui-box-link>
	</div>
	<p [ngClass]="{ 'imv-wrapper__text--easy-read': easyRead }">{{ 'info-variaciones' | translate }}</p>
	<div [ngClass]="easyRead ? 'imv-wrapper__box-link imv-wrapper__box-link--easy-read' : 'imv-wrapper__box-link'">
		<imv-ui-box-link
			eid="other-variations-link"
			class="imv-wrapper__box-link--right"
			extraIcon="./assets/pwa/form/home/variaciones.png"
			[ariaRoleDescription]="'link'"
			[ariaLabel]="'comunica variaciones en tu IMV'"
			(keyup.enter)="navigateVariations()"
			(keyup.space)="navigateVariations()"
			(click)="navigateVariations()"
		>
			<span slot="text">{{ 'variations-boxlink' | translate }}</span>
		</imv-ui-box-link>
	</div>
	<p [ngClass]="{ 'imv-wrapper__text--easy-read': easyRead }">{{ 'info-simulacion' | translate }}</p>
	<div [ngClass]="easyRead ? 'imv-wrapper__box-link imv-wrapper__box-link--easy-read' : 'imv-wrapper__box-link'">
		<a id="other-benefits-link" [attr.aria-label]="'simulator-boxlink' | translate" target="_blank" [href]="employeeSimulationSafeUrl">
			<imv-ui-box-link
				eid="recover-benefits-link"
				class="imv-wrapper__box-link--right"
				extraIcon="./assets/pwa/form/home/incentivo.png"
				[ariaRoleDescription]="'link'"
				[ariaLabel]="'simulador de incentivo al empleo'"
			>
				<span slot="text">{{ 'simulator-boxlink' | translate }}</span>
			</imv-ui-box-link>
		</a>
	</div>
	<div [ngClass]="{ 'imv-wrapper__faq-container': easyRead }">
		<imv-faq *ngIf="appConfig.caiss === 0" (navigateQuestionnaireEmmiter)="navigateQuestionnaire()" [easyRead]="easyRead" class="imv-wrapper__faq-container__faqs"></imv-faq>
	</div>
</div>
<footer class="imv-footer">
	<ng-container *ngIf="appConfig.caiss === 0">
		<article class="imv-footer__item">
			<p class="imv-footer__title">{{ 'footerL-title' | translate }}</p>
			<p class="imv-footer__desc">{{ 'footerL-desc' | translate }}</p>
			<a id="other-benefits-link" class="imv-footer__link" href="{{ moreInfoLink }}" title="Acceder a prestaciones" role="link" attr.aria-label="{{ 'footerL-link' | translate }}"
				>{{ 'footerL-link' | translate
				}}<img class="imv-footer__icon imv-footer__icon--arrow" src="./assets/pwa/home/atoms-icons-24-ico-chevron-right.png" alt="Siguiente" role="link"
			/></a>
		</article>
		<article class="imv-footer__item imv-footer__item--alternative">
			<p class="imv-footer__title">{{ 'footerR-title' | translate }}</p>
			<p class="imv-footer__desc">{{ 'footerR-desc' | translate }}</p>
			<span
				><img class="imv-footer__icon imv-footer__icon--phone" src="./assets/pwa/home/atoms-icons-24-ico-phone.png" alt="Icono teléfono" />{{
					'footerR-telephone' | translate
				}}</span
			>
		</article>
	</ng-container>
</footer>

<imv-ui-modal #modalStartRequest [isMobile]="isMobile" type="email" (closeModal)="onCloseStartRequestModal()" class="modal-align-title">
	<div slot="title">
		<h2 id="modalStartRequestTitle">Iniciar solicitud</h2>
	</div>
	<div slot="content__email">
		<form [formGroup]="formStartRequest">
			<p class="imv-modal__title">
				{{ 'modal-start-text' | translate }}
			</p>
			<div class="control__wrap">
				<imv-form-control
					[showErrors]="submittedStartRequest"
					name="province"
					id="province"
					formControlName="province"
					variant="imv-input"
					type="select"
					[options]="options ? options : []"
					label="{{ 'modal-start-label' | translate }}"
					variant=" modal-home"
				>
				</imv-form-control>
			</div>
		</form>
		<div *ngIf="isDelegatedProvince === 'VASQUE'">
			<p id="delegated-province-message">{{ 'delegated-province-message' | translate }}</p>
			<p>
				<a id="delegated-province-link" title="{{ 'delegated-province-link' | translate }}" href="{{ 'delegated-province-href' | translate }}">{{
					'delegated-province-link' | translate
				}}</a>
			</p>
			<p id="delegated-vasque-province-message">{{ 'delegated-vasque-province-message' | translate }}</p>
			<p>
				<a id="delegated-vasque-province-link" title="{{ 'delegated-vasque-province-link' | translate }}" href="{{ 'delegated-vasque-province-href' | translate }}">{{
					'delegated-vasque-province-link' | translate
				}}</a>
			</p>
		</div>
		<div *ngIf="isDelegatedProvince === 'NAVARRA'">
			<div id="delegated-navarra-province-message">
				<p [innerHTML]="'delegated-province-message-navarra' | translate">
				</p>
				<p>
					{{ 'delegated-navarra-province-link-title' | translate }}
					<a id="delegated-navarra-province-link" title="{{ 'delegated-navarra-province-link-title' | translate }}"
						href="{{ 'delegated-navarra-province-href' | translate }}">{{
						'delegated-navarra-province-link-text' | translate
						}}</a>
				</p>
				<p [innerHTML]="'delegated-province-message-navarra-vasque' | translate">
				</p>
				<p>
					{{ 'delegated-navarra-province-link-title-vasque' | translate }}
					<a id="delegated-navarra-vasque-province-link" title="{{ 'delegated-navarra-province-link-title-vasque' | translate }}"
						href="{{ 'delegated-navarra-vasque-province-href' | translate }}">{{
						'delegated-vasque-province-link' | translate
						}}</a>
				</p>
			</div>
		</div>
		<div *ngIf="isDelegatedProvince === 'CATALUNYA'">
			<p id="delegated-catalunya-province-message">{{ 'delegated-catalunya-province-message' | translate }}</p>
			<p>
				<a id="delegated-catalunya-province-link" title="{{ 'delegated-catalunya-province-link' | translate }}" href="{{ 'delegated-catalunya-province-href' | translate }}">{{
					'delegated-catalunya-province-link' | translate
				}}</a>
			</p>
			<p id="delegated-catalunya-catala-province-message">{{ 'delegated-catalunya-province-message-catala' | translate }}</p>
			<p>
				<a
					id="delegated-catalunya-catala-province-link"
					title="{{ 'delegated-catalunya-province-link-catala' | translate }}"
					href="{{ 'delegated-catalunya-province-href' | translate }}"
					>{{ 'delegated-catalunya-province-link-catala' | translate }}</a
				>
			</p>
		</div>
	</div>
	<div slot="actions">
		<imv-ui-button
			*ngIf="!isDelegatedProvince"
			eid="modal-start-button"
			theme="primary"
			[variant]="isMobile ? '' : 'mdc-button mdc-button--modal'"
			(click)="onSendProvince()"
			[fullWidth]="isMobile"
			class="mobile-full-width"
		>
			<span slot="text">{{ 'modal-start-button' | translate }}</span>
		</imv-ui-button>
	</div>
</imv-ui-modal>

<imv-ui-modal #modalStartProceedings 
	[isMobile]="isMobile" 
	type="email" 
	(closeModal)="onCloseStartProceedings()" 
	class="modal-align-title"
	[imvSetAccessibility]="[{
						selector: 'div.mdc-dialog__surface',
						attributes: {
							'aria-label' : 'province-proceedings'
						}
					}
				]"
	>
	<div slot="title">
		<h2 id="modalStartProceedingsTitle">Gestionar solicitud</h2>
	</div>
	<div slot="content__email">
		<form [formGroup]="formStartProceedings">
			<p class="imv-modal__title-proceedings">
				{{ 'modal-proceedings-start-text' | translate }}
			</p>
			<div class="control__wrap">
				<imv-form-control
					[showErrors]="submittedStartProceedings"
					name="province"
					id="province-proceedings"
					formControlName="province"
					variant="imv-input"
					type="select"
					[options]="options ? options : []"
					label="{{ 'modal-start-label' | translate }}"
					variant=" modal-home"
				>
				</imv-form-control>
			</div>
		</form>
		<br />
		<div *ngIf="isDelegatedProvinceProceedings === 'VASQUE'">
			<p id="delegated-province-message-proceedings">{{ 'delegated-province-message' | translate }}</p>
			<p>
				<a id="delegated-province-link-proceedings" title="{{ 'delegated-province-link-proceedings' | translate }}" href="{{ 'delegated-province-href' | translate }}">{{
					'delegated-province-link' | translate
				}}</a>
			</p>
			<p id="delegated-vasque-province-message-proceedings">{{ 'delegated-vasque-province-message' | translate }}</p>
			<p>
				<a id="delegated-vasque-province-link-proceedings" title="{{ 'delegated-vasque-province-link' | translate }}" href="{{ 'delegated-vasque-province-href' | translate }}">{{
					'delegated-vasque-province-link' | translate
				}}</a>
			</p>
		</div>
		<div *ngIf="isDelegatedProvinceProceedings === 'NAVARRA'">
			<div id="delegated-navarra-province-message-proceedings">

				<p [innerHTML]="'delegated-province-message-navarra' | translate">
				</p>
				<p>
					{{ 'delegated-navarra-province-link-title' | translate }}
					<a id="delegated-navarra-province-link-proceedings" title="{{ 'delegated-navarra-province-link-title' | translate }}"
						href="{{ 'delegated-navarra-province-href' | translate }}">{{
						'delegated-navarra-province-link-text' | translate
						}}</a>
				</p>
				<p [innerHTML]="'delegated-province-message-navarra-vasque' | translate">
				</p>
				<p>
					{{ 'delegated-navarra-province-link-title-vasque' | translate }}
					<a id="delegated-navarra-vasque-province-link-proceedings" title="{{ 'delegated-navarra-province-link-title-vasque' | translate }}"
						href="{{ 'delegated-navarra-vasque-province-href' | translate }}">{{
						'delegated-vasque-province-link' | translate
						}}</a>
				</p>
			</div>
		</div>
	</div>
	<div slot="actions" class="mt-0">
		<imv-ui-button
			*ngIf="!isDelegatedProvinceProceedings"
			eid="modal-start-button-proceedings"
			theme="primary"
			[fullWidth]="isMobile"
			[variant]="isMobile ? '' : 'mdc-button mdc-button--modal'"
			(click)="onSendProvinceStartProceedings()"
			class="mobile-full-width"
		>
			<span slot="text">{{ 'modal-start-button' | translate }}</span>
		</imv-ui-button>
	</div>
</imv-ui-modal>

<imv-ui-modal #modalStartVariations [isMobile]="isMobile" type="email" (closeModal)="onCloseStartVariations()">
	<h2 slot="title" id="modalStartVariationsTitle">Comunicar variaciones en tu IMV</h2>
	<div slot="content__email">
		<form [formGroup]="formStartVariations">
			<p class="imv-modal__title-variations">
				{{ 'modal-variations-start-text' | translate }}
			</p>
			<div class="control__wrap">
				<imv-form-control
					[showErrors]="submittedStartVariations"
					name="province"
					id="province-variations"
					formControlName="province"
					variant="imv-input"
					type="select"
					[options]="options ? options : []"
					label="{{ 'modal-start-label' | translate }}"
					variant=" modal-home"
				>
				</imv-form-control>
			</div>
		</form>
		<br />
		<div *ngIf="isDelegatedProvinceVariations === 'VASQUE'">
			<p id="delegated-province-message-variations">{{ 'delegated-province-message' | translate }}</p>
			<p>
				<a id="delegated-province-link-variations" title="{{ 'delegated-province-link' | translate }}" href="{{ 'delegated-province-href' | translate }}">{{
					'delegated-province-link' | translate
				}}</a>
			</p>
			<p id="delegated-vasque-province-message-variations">{{ 'delegated-vasque-province-message' | translate }}</p>
			<p>
				<a id="delegated-vasque-province-link-variations" title="{{ 'delegated-vasque-province-link' | translate }}" href="{{ 'delegated-vasque-province-href' | translate }}">{{
					'delegated-vasque-province-link' | translate
				}}</a>
			</p>
		</div>
		<div *ngIf="isDelegatedProvinceVariations === 'NAVARRA'">
			<div id="delegated-navarra-province-message-variations">
				<p [innerHTML]="'delegated-province-message-navarra' | translate"></p>
				<p>
					{{ 'delegated-navarra-province-link-title' | translate }}
					<a
						id="delegated-navarra-province-link-variations"
						title="{{ 'delegated-navarra-province-link-title' | translate }}"
						href="{{ 'delegated-navarra-province-href' | translate }}"
						>{{ 'delegated-navarra-province-link-text' | translate }}</a
					>
				</p>
				<p [innerHTML]="'delegated-province-message-navarra-vasque' | translate"></p>
				<p>
					{{ 'delegated-navarra-province-link-title-vasque' | translate }}
					<a
						id="delegated-navarra-vasque-province-link-variations"
						title="{{ 'delegated-navarra-province-link-title-vasque' | translate }}"
						href="{{ 'delegated-navarra-vasque-province-href' | translate }}"
						>{{ 'delegated-vasque-province-link' | translate }}</a
					>
				</p>
			</div>
		</div>
		<div *ngIf="isDelegatedProvinceVariations === 'CATALUNYA'">
			<p id="delegated-catalunya-variations-inss-message">{{ 'delegated-catalunya-variations-inss-message' | translate }}</p>
			<p>
				<a
					id="delegated-catalunya-variations-inss-link"
					title="{{ 'delegated-catalunya-variations-inss-link' | translate }}"
					href="{{ 'delegated-catalunya-variations-inss-href' | translate }}"
					>{{ 'delegated-catalunya-variations-inss-link' | translate }}</a
				>
			</p>
			<p id="delegated-catalunya-variations-oac-message">{{ 'delegated-catalunya-variations-oac-message' | translate }}</p>
			<p>
				<a
					id="delegated-catalunya-variations-oac-link"
					title="{{ 'delegated-catalunya-variations-oac-link' | translate }}"
					href="{{ 'delegated-catalunya-variations-oac-href' | translate }}"
					>{{ 'delegated-catalunya-variations-oac-link' | translate }}</a
				>
			</p>
		</div>
	</div>
	<div slot="actions">
		<imv-ui-button
			*ngIf="!isDelegatedProvinceVariations"
			eid="modal-start-button-variations"
			theme="primary"
			variant=" mdc-button mdc-button--modal"
			(click)="onSendProvinceStartVariations()"
		>
			<span slot="text">{{ 'modal-start-button' | translate }}</span>
		</imv-ui-button>
	</div>
</imv-ui-modal>

<imv-ui-modal #modalAccessDraft [isMobile]="isMobile" type="email" (closeModal)="onCloseAccessDraftModal()">
	<h2 slot="title" id="modalAccessDraftTitle">{{ 'modal-draft-title' | translate }}</h2>
	<div slot="content__email">
		<form [formGroup]="formAccessDraft">
			<p class="imv-modal__title" id="access-draft-modal-title">{{ 'modal-draft-subtitle' | translate }}</p>
			<ul>
				<li>{{ 'modal-draft-access-text' | translate }}</li>
			</ul>
			<imv-form-control
				[upperCase]="false"
				name="accessDraftToken"
				id="accessDraftToken"
				formControlName="accessDraftToken"
				variant="imv-input imv-input--full"
				type="text"
				label="{{ 'modal-access-label' | translate }}"
				[maxLength]="8"
				[showErrors]="formAccessDraft.dirty"
			>
			</imv-form-control>
		</form>
		<br />
		<div class="imv-info__text--center">
			<a id="resend-email-link" *ngIf="appConfig.caiss === 0" href="javascript:void(0)" (click)="onReferenceRequest()" class="imv-info__text imv-info__text--center">{{
				'resend' | translate
			}}</a
			><br />
		</div>
	</div>
	<div slot="actions">
		<imv-ui-button [disabled]="formAccessDraft.invalid" eid="access-draft-modal-button" theme="primary" variant=" mdc-button mdc-button--modal" (click)="onSendAccessDraftToken()">
			<span slot="text">{{ 'modal-start-button' | translate }}</span>
		</imv-ui-button>
	</div>
</imv-ui-modal>

<imv-ui-modal #modalAccessProceedings [isMobile]="isMobile" type="email" (closeModal)="onCloseAccessProceedingsModal()">
	<h2 slot="title" id="modalAccessProceedingsTitle">{{ 'modal-access-title' | translate }}</h2>
	<div slot="content__email">
		<form [formGroup]="formAccessProceedings">
			<p class="imv-modal__title">{{ 'modal-access-subtitle' | translate }}</p>
			<ul>
				<li>{{ 'modal-draft-access-text' | translate }}</li>
			</ul>
			<imv-form-control
				[upperCase]="false"
				name="accessProceedingsToken"
				id="accessProceedingsToken"
				formControlName="accessProceedingsToken"
				variant="imv-input imv-input--full"
				type="text"
				label="{{ 'modal-access-label' | translate }}"
				[maxLength]="8"
				[showErrors]="formAccessProceedings.dirty"
			>
			</imv-form-control>
		</form>
		<br />
		<div class="imv-info__text--center">
			<a id="resend-email-link-proceedings" *ngIf="appConfig.caiss === 0" href="javascript:void(0)" (click)="onReferenceConsult()" class="imv-info__text imv-info__text--center">{{
				'resend' | translate
			}}</a
			><br />
		</div>
	</div>
	<div slot="actions">
		<imv-ui-button
			[disabled]="formAccessProceedings.invalid"
			eid="access-proceedings-modal-button"
			theme="primary"
			variant=" mdc-button mdc-button--modal"
			(click)="onSendAccessProceedingsToken()"
		>
			<span slot="text">{{ 'modal-start-button' | translate }}</span>
		</imv-ui-button>
	</div>
</imv-ui-modal>
